import React from 'react';

export const VideoPlayOverlay: React.FC = () => (
    <div className="video-play-button-overlay">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="rgba(0, 0, 0, 0.7)" />
            <path d="M10 8.5v7l6-3.5-6-3.5z" fill="white" />
        </svg>
    </div>
);
